import { render, staticRenderFns } from "./PasswordConfirmation.vue?vue&type=template&id=2945c6dc"
import script from "./PasswordConfirmation.vue?vue&type=script&lang=ts"
export * from "./PasswordConfirmation.vue?vue&type=script&lang=ts"
import style0 from "./PasswordConfirmation.vue?vue&type=style&index=0&id=2945c6dc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports